// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Q0lL","inner":"Form_inner__35AYP","range":"Form_range__Se_ad","name":"Form_name__ToX-B","actions":"Form_actions__3RUvA"};